export default __webpack_public_path__ + "static/media/rainforest5.bb00559c.jpg";